import { Routes, Route, Navigate } from 'react-router-dom';
import { useScrollToTop } from './hooks/useScrollToTop';
import Navigation from './components/Navigation';
import Landing from './pages/Landing';
import Features from './pages/Features';
import About from './pages/About';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import { DarkModeProvider } from './context/DarkModeContext';
import AIPocket from './components/AIPocket';

const App = () => {
  useScrollToTop();

  return (
    <DarkModeProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/features" element={<Features />} />
          <Route path="/about" element={<About />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Navigation />
        <AIPocket />
      </div>
    </DarkModeProvider>
  );
};

export default App;